export default {
  title: 'ใบแจ้งหนี้',
  // MON-4 decision D: invoice-specific badge copy, not the generic
  // status.pending/unpaid strings shared with parcels in the common
  // namespace. See liff/src/lib/invoiceStatus.ts.
  status: {
    paid: 'ชำระแล้ว',
    pending_payment: 'รอชำระ',
    overdue: 'ค้างชำระ',
    partially_paid: 'ชำระบางส่วน',
  },
  test_mode_amount: 'โหมดทดสอบ: ฿{{amount}}',
  amount_via_promptpay: '฿{{amount}} ผ่านพร้อมเพย์',
  invoice_number: 'ใบแจ้งหนี้ #{{number}}',
  billed_at: 'วันที่ออก',
  due_at: 'วันครบกำหนด',
  total: 'ยอดรวม',
  amount_paid: 'ชำระแล้ว',
  remaining: 'คงเหลือ',
  items: 'รายการ',
  payments: 'ประวัติการชำระ',
  no_invoices: 'ไม่พบใบแจ้งหนี้',
  no_payment_methods: 'ยังไม่ได้ตั้งค่าช่องทางชำระเงินออนไลน์ กรุณาติดต่อผู้จัดการทรัพย์สิน',
  pay_button: 'ชำระ ฿{{amount}}',
  payment_method: 'วิธีชำระเงิน',
  promptpay: 'พร้อมเพย์ (QR)',
  credit_card: 'บัตรเครดิต',
  bank_transfer: 'โอนผ่านธนาคาร',
  bank_transfer_details: 'โอนเงินไปยังบัญชีต่อไปนี้',
  bank_name: 'ธนาคาร',
  account_name: 'ชื่อบัญชี',
  account_number: 'เลขที่บัญชี',
  transfer_amount: 'จำนวนเงินที่โอน',
  upload_slip: 'อัปโหลดสลิปการโอน',
  tap_to_upload: 'แตะเพื่อเลือกรูปสลิป',
  submit_slip: 'ส่งสลิป',
  slip_submitted: 'ส่งสลิปแล้ว',
  pending_verification: 'รอแอดมินตรวจสอบการชำระเงินของคุณ',
  scan_qr: 'สแกน QR เพื่อชำระเงิน',
  generating_qr: 'กำลังสร้าง QR Code...',
  waiting_confirmation: 'รอการยืนยันการชำระเงิน...',
  payment_success: 'ชำระเงินสำเร็จ!',
  payment_failed: 'การชำระเงินล้มเหลว',
  card_details: 'ข้อมูลบัตร',
  confirm_payment: 'ยืนยันการชำระ',
  polling_message: 'กำลังตรวจสอบสถานะการชำระ...',
  download_pdf: 'ดาวน์โหลด PDF ใบแจ้งหนี้',
  errors: {
    stripe_not_configured: 'ไม่สามารถชำระเงินออนไลน์ได้ กรุณาติดต่อผู้จัดการทรัพย์สิน',
  },
}
